import { Card, CardContent } from "../ui/card";
import { Clipboard, AlertTriangle, Clock, X, TrendingUp, CheckCircle } from "lucide-react";

interface SummaryData {
  totalReq: number;
  openReq: number;
  stagnantReq: number;
  rejectedReq: number;
  sanctionedReq: number;
  disbursedReq: number;
  toBeLoggedIn: number;
  droppedCases: number;
  toBeLoggedInDashboardCount: number;
}

interface SummaryCardsProps {
  data: SummaryData;
  onCardClick?: (filter: 'totalReq' | 'toBeLoggedIn' | 'stagnantReq' | 'rejectedReq' | 'sanctionedReq' | 'disbursedReq') => void;
}

export function SummaryCards({ data, onCardClick }: SummaryCardsProps) {
  const formatCr = (amount?: number) => {
    const n = Number(amount ?? 0);
    const cr = n / 1_00_00_000;
    return `₹${cr.toFixed(2)} Cr`;
  };

  const cards = [
    {
      title: "Total Requirements",
      value: data?.totalReq,
      icon: Clipboard,
      gradient: "from-primary/5 to-transparent",
      key: "totalReq" as const
    },
    {
      title: "To be logged in",
      value: data?.toBeLoggedInDashboardCount,
      icon: Clock,
      gradient: "from-blue-500/5 to-transparent",
      key: "toBeLoggedInDashboardCount" as const
    },
    {
      title: "Requirements Stagnant",
      value: data?.stagnantReq,
      icon: AlertTriangle,
      gradient: "from-orange-500/5 to-transparent",
      key: "stagnantReq" as const
    },
    {
      title: "Rejected",
      value: data?.rejectedReq,
      icon: X,
      gradient: "from-red-500/5 to-transparent",
      key: "rejectedReq" as const
    },
    {
      title: "Sanctioned",
      value: data?.sanctionedReq,
      icon: TrendingUp,
      gradient: "from-green-500/5 to-transparent",
      key: "sanctionedReq" as const
    },
    {
      title: "Disbursed",
      value: data?.disbursedReq,
      icon: CheckCircle,
      gradient: "from-emerald-500/5 to-transparent",
      key: "disbursedReq" as const
    }
  ];

  return (
    <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {cards.map((card) => (
        <Card 
          key={card.title} 
          className={`overflow-hidden transition-all duration-200 `}
          
        >
          <CardContent className={`p-4 bg-gradient-to-br ${card.gradient}`}>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs text-muted-foreground">{card.title}</div>
                <div className="mt-1 text-2xl font-semibold">
                  {card.key === "sanctionedReq" || card.key === "disbursedReq"
                    ? formatCr(card.value)
                    : card.value}
                </div>
              </div>
              <div className="h-10 w-10 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                <card.icon className="h-5 w-5" />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </section>
  );
}